'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDeviceDetect = require('react-device-detect');

var _Container = require('./components/Container.Frame');

var _Container2 = _interopRequireDefault(_Container);

var _Content = require('./components/Content.Frame');

var _Content2 = _interopRequireDefault(_Content);

var _Bar = require('./components/Bar.Frame');

var _Bar2 = _interopRequireDefault(_Bar);

var _Frame = require('./components/Frame.Frame');

var _Frame2 = _interopRequireDefault(_Frame);

var _Image = require('./components/Image.Frame');

var _Image2 = _interopRequireDefault(_Image);

var _Download = require('./components/Download.Frame');

var _Download2 = _interopRequireDefault(_Download);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components


var FrameDoc = function (_Component) {
  _inherits(FrameDoc, _Component);

  function FrameDoc() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FrameDoc);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FrameDoc.__proto__ || Object.getPrototypeOf(FrameDoc)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      fullscreen: false
    }, _this.toggleFullscreen = function () {
      return _this.setState({
        fullscreen: !_this.state.fullscreen
      });
    }, _this.src = function () {
      return '' + (_reactDeviceDetect.isMobile ? 'https://drive.google.com/viewerng/viewer?embedded=true&url=' : '') + _this.props.file.document_file;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FrameDoc, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          file = _props.file,
          height = _props.height,
          fullscreenable = _props.fullscreenable,
          onRemove = _props.onRemove,
          displayOnMobile = _props.displayOnMobile,
          props = _objectWithoutProperties(_props, ['file', 'height', 'fullscreenable', 'onRemove', 'displayOnMobile']);

      var fullscreen = this.state.fullscreen;
      return _react2.default.createElement(_Container2.default, {
        height: height,
        fullscreen: fullscreen
      }, (fullscreenable || !!onRemove) && _react2.default.createElement(_Bar2.default, {
        fullscreenable: fullscreenable,
        fullscreen: fullscreen,
        onClick: this.toggleFullscreen,
        onRemove: onRemove
      }), _react2.default.createElement(_Content2.default, null, _react2.default.createElement(_Download2.default, {
        file: file,
        displayOnMobile: displayOnMobile
      }, file.file_extension !== 'pdf' ? _react2.default.createElement(_Image2.default, {
        src: file.document_file
      }) : _react2.default.createElement(_Frame2.default, _extends({
        src: this.src()
      }, props)))));
    }
  }]);

  return FrameDoc;
}(_react.Component);

FrameDoc.propTypes = {
  file: _propTypes2.default.object.isRequired,
  height: _propTypes2.default.string,
  onRemove: _propTypes2.default.func,
  fullscreenable: _propTypes2.default.bool,
  displayOnMobile: _propTypes2.default.bool
};
FrameDoc.defaultProps = {
  height: '100%',
  fullscreenable: false,
  displayOnMobile: false,
  onRemove: null
};
exports.default = FrameDoc;